import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Textarea from '../../../../components/form/Textarea'
import Input from '../../../../components/form/Input'

const SetupSection = () => {
  const { t } = useTranslation('editFormV2')

  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        {t('setupSection')}
      </Title>
      <Line />
      <Separator weight={4} />

      <Grid paddingGutter={0.5} wrap>
        <Col width="100%" wrapOn="sm">
          <FormItem label={t('conclusionTitle')} path={['configuration', 'titleMessage']} Input={Input} />
        </Col>
      </Grid>

      <Grid paddingGutter={0.5} wrap>
        <Col width="100%" wrapOn="sm">
          <FormItem label={t('conclusionBody')} path={['configuration', 'bodyMessage']} Input={Textarea} />
        </Col>
      </Grid>
    </>
  )
}

export default SetupSection
